import { render, staticRenderFns } from "./CustomerClusterList.vue?vue&type=template&id=0d554113"
import script from "./CustomerClusterList.vue?vue&type=script&lang=js"
export * from "./CustomerClusterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports